import { useState, useEffect } from "react";
import services from "commons/apis/index";
import Cookies from "js-cookie";

const useGetAgents = ({ limit }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const role = Number(Cookies.get("role"));
  const agentId = Cookies.get("agentId");

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const { items } = await services.getAgents({ limit });
        const newData =
          role === 4
            ? items
            : items.filter((item) => item.agent.id === Number(agentId));
        setData(newData);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, agentId]);

  return {
    data: data ?? [],
    loading,
  };
};
export default useGetAgents;
